import KitElement from './kit_element';

export default KitElement;
